import React, { useEffect, useState } from "react";
import SingleArticle from "./SingleArticle";
import { Article, Articles } from "./articleHelpers";
import TextField from "@mui/material/TextField";
import MenuItem from "@mui/material/MenuItem";
import Box from "@mui/material/Box";
import AdapterDateFns from "@mui/lab/AdapterDateFns";
import LocalizationProvider from "@mui/lab/LocalizationProvider";
import DateTimePicker from "@mui/lab/DateTimePicker";
import config from "./config";

const reducer = (oldestDate: number, newValue: Article) =>
  newValue.createdAt && newValue.createdAt < oldestDate
    ? newValue.createdAt
    : oldestDate;

const oldestCreationTimestamp = (articles: Articles): Date =>
  new Date(Object.values(articles).reduce(reducer, Date.now()));

const ArticlesList: React.FC<{
  articles?: Articles;
}> = ({ articles }) => {
  const [selectedBlog, setSelectedBlog] = useState<string>(config.defaultBlog);
  const [minCreationDate, setMinCreationDate] = useState<Date | null>();
  const [titleContains, setTitleContains] = useState("");

  useEffect(() => {
    document.title = "Tous les articles";
  }, []);

  useEffect(() => {
    if (articles) {
      setMinCreationDate(oldestCreationTimestamp(articles));
    }
  }, [articles]);

  /* const filterByBlog = (article: Article) =>
    article.blog === selectedBlog ||
    selectedBlog === "Tous les blogs" ||
    !selectedBlog; */

  const filterByCreationDate = (article: Article) =>
    article.createdAt &&
    minCreationDate &&
    article.createdAt >= minCreationDate.getTime();

  const filterByTitle = (article: Article) =>
    article.title && article.title.match(new RegExp(titleContains, "i"));

  return (
    <>
      <Box
        component="form"
        sx={{
          "& .MuiTextField-root": { m: 1, width: "25ch" },
        }}
        noValidate
        autoComplete="off"
      >
        <TextField
          disabled
          select
          label="Blog"
          value={selectedBlog}
          onChange={({ target }) => {
            setSelectedBlog(target.value);
          }}
        >
          {["Tous les blogs", config.defaultBlog].map((option) => (
            <MenuItem key={option} value={option}>
              {option}
            </MenuItem>
          ))}
        </TextField>
        <LocalizationProvider dateAdapter={AdapterDateFns}>
          <DateTimePicker
            renderInput={(props) => <TextField {...props} />}
            label="Créé à partir de"
            value={minCreationDate}
            onChange={(newValue) => {
              setMinCreationDate(newValue);
            }}
          />
        </LocalizationProvider>
        <TextField
          label="Titre contient"
          value={titleContains}
          onChange={({ target }) => {
            setTitleContains(target.value);
          }}
        ></TextField>
      </Box>
      {articles &&
        Object.entries(articles).map(
          ([articleId, article]) =>
            // filterByBlog(article) &&
            filterByCreationDate(article) &&
            filterByTitle(article) && (
              <SingleArticle
                articleId={articleId}
                article={article}
                key={articleId}
              />
            )
        )}
    </>
  );
};

export default ArticlesList;
